import { WalletBonus } from "../modules/walletBonus";

export const WalletBonusPages = () => {
  return <WalletBonus />;
};
